import { useQuery } from '@tanstack/react-query';
import { ServiceFactory } from '../../../../services/ServiceFactory';
import { QUOTES_DEFAULTS } from '../../../../services/quotes/QuotesService';

export const useQuotes = (currentPage: number) => {
  const limit = QUOTES_DEFAULTS.LIMIT;
  const offset = limit * (currentPage - 1);

  const { data, status } = useQuery({
    queryKey: ['quotes', { limit, offset }],
    queryFn: () => ServiceFactory
      .createQuotesService()
      .getQuotes(limit, offset),
  });

  return {
    results: data?.results || [],
    total: data?.total || 0,
    status,
  };
};

export const useQuoteStatuses = () => {
  const { data, status } = useQuery({
    queryKey: ['quote-statuses'],
    queryFn: () => ServiceFactory.createQuotesService().getQuoteStatuses(),
  });

  return {
    results: data?.results || [],
    status,
  };
};
